import { Flex, ProductColor, Typography } from '@aloft/toolkit-sui';

import { PropertyPinStatus } from '../../Tkv2Map/types.ts';
import { ValuationTablePropertyHeaderDistanceToSubject } from './ValuationTablePropertyHeaderDistanceToSubject.tsx';
import { ValuationTablePropertyHeaderPin } from './ValuationTablePropertyHeaderPin.tsx';

type ValuationTablePropertyHeaderTitleProps = {
  hideActions: boolean;
  pinColor: ProductColor;
  pinStatus: PropertyPinStatus;
  propertyId: string;
  title: string;
  hideDistanceToSubject?: boolean;
};

export const ValuationTablePropertyHeaderTitle = ({
  hideActions,
  pinColor,
  pinStatus,
  title,
  propertyId,
  hideDistanceToSubject,
}: ValuationTablePropertyHeaderTitleProps) => (
  <Flex alignItems="center" whiteSpace="nowrap">
    <Flex gap="0.5rem" alignItems="center">
      <ValuationTablePropertyHeaderPin
        hideActions={hideActions}
        pinColor={pinColor}
        pinStatus={pinStatus}
      />
      <Typography variant="h3" __dangerDoNotUseSx={{ fontSize: '14px' }}>
        {title}
      </Typography>
      {!hideDistanceToSubject && (
        <ValuationTablePropertyHeaderDistanceToSubject propertyId={propertyId} />
      )}
    </Flex>
  </Flex>
);
